import { normalizeWaveform } from '@djs';
import { PreparedValues } from './types';

/**
 * Расчет размеров канваса в зависимости от ширины баббла и количества волн голосового
 */
export const calcPreparedValues = (
  canvasEl: HTMLCanvasElement,
  waveform: number[],
  lineWidth: number,
  lineGap: number,
  minValidRawValuesMaximum: number,
): PreparedValues | undefined => {
  const parentWidth = canvasEl.clientWidth;
  const parentHeight = canvasEl.clientHeight;
  const ctx = canvasEl.getContext('2d');

  if (!ctx || !parentWidth) return;

  const color = getComputedStyle(canvasEl).getPropertyValue('--wave-color');

  const onePartWidth = lineWidth + lineGap;
  const waveformLength = Math.floor(parentWidth / onePartWidth);
  const width = waveformLength * onePartWidth;

  return {
    values: normalizeWaveform(waveform, minValidRawValuesMaximum, {
      length: { min: waveformLength, max: waveformLength },
      values: { min: 3, max: parentHeight },
    }),
    width,
    height: parentHeight,
    color,
    left: canvasEl.getBoundingClientRect().left,
  };
};

/**
 * Отрисовка канваса по заранее заготовленным параметрам
 */
export const initCanvas = (canvasEl: HTMLCanvasElement, preparedValues: PreparedValues, dpr: number) => {
  const ctx = canvasEl.getContext('2d');

  if (!ctx) {
    return;
  }

  const { height, width } = preparedValues;
  canvasEl.width = width * dpr;
  canvasEl.height = height * dpr;

  ctx.reset();
  ctx.scale(dpr, dpr);
};

interface DrawParams {
  percent: number;
  lineWidth: number;
  lineGap: number;
}

/**
 * Отрисовка волн
 */
export const drawValues = (canvasEl: HTMLCanvasElement, preparedValues: PreparedValues, params: DrawParams) => {
  const { lineGap, lineWidth, percent = 1 } = params;
  const { color, height, values } = preparedValues;
  const ctx = canvasEl.getContext('2d');

  if (!ctx) return;

  ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
  ctx.fillStyle = color;

  const onePartWidth = lineWidth + lineGap;
  const maxIndex = Math.round(values.length * percent);

  ctx.translate(0, height / 2);

  values.forEach((value, index) => {
    ctx.globalAlpha = index < maxIndex ? 1 : 0.48;
    ctx.beginPath();
    ctx.roundRect(index * onePartWidth, -value / 2, lineWidth, value, 2);
    ctx.fill();
    ctx.closePath();
  });

  ctx.translate(0, -height / 2);
};
